import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsPOCPODchecked extends React.Component {
  constructor(props) {
    super(props);
    window.helloComponent = this;
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsPrechecked: "/api/v1/portal/jobs/set-as/toggle/",
      isAppraisalChecked: props.data.is_appraisal_checked || false,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleMarkJobAsPrechecked(event, appraisalChecked) {
    return fetch(
      this.state.apiUrlForToggleMarkJobAsPrechecked +
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        body: JSON.stringify({
          isChecked: appraisalChecked
        }),
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((response) => {
      return response.json();
    }).then((response) => {
      if (response.toggleAppraisalChecked == 1) {
        $('#jobs-table-row-'+this.state.data.id+'').addClass('row-status-bg-poc-pod-prechecked');
        this.setState({isAppraisalChecked: true});
      }
      else {
        $('#jobs-table-row-'+this.state.data.id+'').removeClass('row-status-bg-poc-pod-prechecked');
        this.setState({isAppraisalChecked: false});
      }
    });
    
  }
  
  render() {
    return (
      <span>
        {(this.state.isAppraisalChecked) ? 
        <p className="preChecked"><button className="btn btn-lg row-status-bg-is_appraisal_checked btn-orange">
        Job POC and POD checked&nbsp;{
            (this.state.data?.marked_as_has_a_major_issue_by !== null) ?
              <span>
                      {
                        this.state.data.marked_as_has_a_major_issue_by.first_name+' '+
                        this.state.data.marked_as_has_a_major_issue_by.last_name+
                        ' on '+
                        this.state.data.marked_as_has_a_major_issue_at
                      }
                  </span>
              : ''
          }
      </button>&nbsp;
        <button
          className="btn btn-lg btn-dark"
          title={"Toggle Unmark Job as: Prechecked"}
          onClick={(e) => this.toggleMarkJobAsPrechecked(e, 0)}
        >
          <i className="fa fa-undo"></i>&nbsp;
          Unmark Job As POC and POD Prechecked
        </button></p> : 
        <p className="notPreChecked">Job Appraisal Not Prechecked<br />
        <button
          className="btn btn-lg btn-dark"
          title={"Toggle Mark Job as: PreChecked"}
          onClick={(e) => this.toggleMarkJobAsPrechecked(e, 1)}
        >
          Mark Job As POC and POD Prechecked
        </button>
      </p>
      }
      </span>
    )
  }
}